import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=89a33534&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=89a33534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a33534",
  null
  
)

export default component.exports